import { Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

// Portal badge system (bdg): inline-flex pill, 2px 8px padding, 8px radius,
// 11px / 500, 16px line-height. Colors map status -> { bg, fg }.
const badgeBase = {
  display: "inline-flex",
  alignItems: "center",
  padding: "4px 12px",
  borderRadius: "8px",
  fontSize: "11px",
  fontWeight: 500,
  lineHeight: "16px",
  whiteSpace: "nowrap",
};

export const getStatusColors = (colors, status = "") => {
  const RUNNING = { bg: colors.okBg, fg: colors.okFg };
  const HIBERNATED = { bg: colors.neuBg, fg: colors.neuFg };
  const FAILED = { bg: colors.errBg, fg: colors.errFg };
  const IN_PROGRESS = { bg: colors.infoBg, fg: colors.infoFg };
  const NEW_ITEM = { bg: colors.warnBg, fg: colors.warnFg };

  const value = String(status).toUpperCase();
  if (value.includes("FAILED") || value === "REJECTED") return FAILED;
  if (value === "RUNNING" || value === "DEPLOYED" || value === "APPROVED")
    return RUNNING;
  if (
    value.includes("COMPLETE") ||
    value.includes("SUCCESS") ||
    value.includes("SUCCEEDED")
  )
    return RUNNING;
  if (value === "HIBERNATED" || value === "DELETED") return HIBERNATED;
  if (value === "NEW") return NEW_ITEM;
  if (value.includes("SEVERITY")) {
    if (value.includes("HIGH") || value.includes("CRITICAL")) return FAILED;
    if (value.includes("MEDIUM")) return NEW_ITEM;
    return HIBERNATED;
  }
  return IN_PROGRESS;
};

// Enums the generic sentence-case rule cannot word-split correctly.
const STATUS_LABELS = {
  WAKEUP_FAILED: "Wake up failed",
};

// Everything else goes SNAKE_CASE -> "Sentence case": UPDATE_FAILED -> "Update failed".
export const getStatusLabel = (status) => {
  const value = String(status ?? "").toUpperCase();
  if (STATUS_LABELS[value]) return STATUS_LABELS[value];
  const words = value.replace(/_/g, " ").toLowerCase().trim();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : status;
};

const StatusChip = ({ value, sx }) => {
  const theme = useTheme();
  if (!value) return null;
  const { bg, fg } = getStatusColors(tokens(theme.paletteId), value);
  return (
    <Box
      component="span"
      sx={{ ...badgeBase, background: bg, color: fg, ...sx }}
    >
      {getStatusLabel(value)}
    </Box>
  );
};

export default StatusChip;
